module.exports = __webpack_public_path__ + "img/molecule.f4c7830a.png";